import { ZmianaKlucza } from '@/components/ZmianaKlucza';
import { checkGroupCode, zmienKodGrupy } from '@/lib/employee-groups-api';
import { useI18n } from '@/lib/i18n';

/**
 * ZMIANA KODU GRUPY PRACOWNICZEJ — odmiana wspólnego okna zmiany klucza.
 *
 * ⚠️ BEZ PTASZKA HISTORII, w odróżnieniu od numeru karty. `TransactionLog` trzyma grupy zamrożone
 * w chwili wydania w dziesięciu kolumnach (`USERGROUP01..10`); rejestr jest tabelą zakazaną,
 * a jedyny wyłom dotyczy jednego wiersza wskazanego przez `TLID`. SPS też historii nie przepisuje
 * — i to jest poprawne: grupa z zeszłego roku nazywała się wtedy inaczej.
 */
export function ZmianaKoduGrupy({
  grupaId,
  islandId,
  obecnyKod,
  nazwa,
  onClose,
  onSaved,
}: {
  grupaId: string;
  islandId: string;
  obecnyKod: string;
  nazwa: string;
  onClose: () => void;
  onSaved: () => void;
}) {
  const { t } = useI18n();

  return (
    <ZmianaKlucza
      tytul={t('grp.codeChangeTitle')}
      podpis={`${nazwa} · ${obecnyKod}`}
      wstep={t('grp.codeChangeIntro')}
      ostrzezenie={t('grp.codeChangeWarn')}
      etykietaPola={t('grp.codeChangeNew')}
      obecny={obecnyKod}
      /** `UserGroups.USERGROUPNUMBER` — 32 znaki. */
      limit={32}
      sprawdz={(v) => checkGroupCode(islandId, v)}
      zapisz={async (nowy) => {
        const r = await zmienKodGrupy(grupaId, { groupId: islandId, nowyKod: nowy });
        return t('grp.codeChanged').replace('{stary}', r.stary).replace('{nowy}', r.nowy);
      }}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
